
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30575',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30575",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55006",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8177",
  "hubspot-dlb": "static-2.1854",
  "HubStyleTokens": "static-2.11624",
  "I18n": "static-7.1643",
  "quartz": "static-1.7233",
  "quartz-config": "static-1.1011",
  "quartz-core": "static-1.6452",
  "react-dlb": "static-1.82",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.43",
  "reselect": "static-3.7",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.836",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.54993",
  "feedback-utils": "static-1.54997",
  "forms-embed-utils-lib": "static-1.4619",
  "forms-utils-lib": "static-1.12878",
  "foundations-assets": "static-1.5029",
  "foundations-components": "static-1.8241",
  "foundations-theming": "static-1.4593",
  "hub-http": "static-1.6376",
  "hubspot-url-utils": "static-1.4132",
  "HubStyle": "static-2.11931",
  "icons": "static-2.660",
  "immutable": "static-2.79",
  "quick-fetch": "static-1.4030",
  "raven": "static-3.5925",
  "react": "static-7.188",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16850",
  "react-select-plus": "static-1.107",
  "react-utils": "static-2.5454",
  "react-virtualized": "static-2.101",
  "redux": "static-4.16",
  "StyleGuideUI": "static-3.490",
  "tinymce-plugins": "static-1.57899",
  "transmute": "static-2.85",
  "ui-images": "static-2.1196",
  "UIComponents": "static-3.8570",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9637",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3514",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3510",
  "quartz-webpack": "static-1.3457",
  "foundations-theming-specialty": "static-1.2309",
  "property-description-translator": "static-1.3995",
  "HeadJS": "static-2.775",
  "framer-motion": "static-1.74",
  "hs-test-utils-bend-plugin": "static-1.3288",
  "msw": "static-1.39",
  "testing-library": "static-1.154",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.224",
  "moment-timezone": "static-5.85",
  "jasmine": "static-4.4480",
  "jasmine-runner": "static-1.6612",
  "dispatcher": "static-1.139",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.850",
  "hubspotter-http": "static-1.4764",
  "mobile-manifest-mixins": "static-1.549",
  "module-federation": "static-1.28",
  "quartz-auth": "static-1.908",
  "quartz-head": "static-1.898",
  "quartz-i18n": "static-1.908",
  "quartz-routing": "static-1.663",
  "quartz-test": "static-1.908",
  "quartz-tracking": "static-1.612",
  "trellis-components": "static-1.2272",
  "ui-fonts": "static-1.886",
  "usage-tracker-container": "static-1.7497",
  "usage-tracker-core": "static-1.7357",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.159",
  "conversations-skeleton-state": "static-1.7403",
  "reference-resolvers": "static-1.8331",
  "sanitize-text": "static-1.8302",
  "PatternValidationJS": "static-1.437",
  "ReduxMessenger": "static-2.10519",
  "sanitize": "static-1.4633",
  "outpost": "static-1.4325",
  "rpc-client-utils": "static-1.4815",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4510",
  "floating-ui": "static-1.59",
  "hs-story-utils": "static-1.9579",
  "react-aria": "static-1.68",
  "react-create-root-preference": "static-1.41",
  "tanstack-table": "static-1.57",
  "trellis-assets": "static-1.2253",
  "bend-plugin-foundations-theming": "static-1.3076",
  "foundations-theming-base": "static-1.3578",
  "stylex": "static-1.36",
  "hs-locale-management": "static-1.195",
  "csstype": "static-1.50",
  "web-vitals": "static-1.8",
  "ai-components-ui-library": "static-1.9344",
  "atom": "static-1.5230",
  "codemirror": "static-5.97",
  "content-assistance-lib": "static-1.7998",
  "ContentUtils": "static-1.68818",
  "data-token-picker": "static-1.16686",
  "file-manager-components": "static-1.24082",
  "FileManagerCore": "static-1.39581",
  "FileManagerLib": "static-1.39722",
  "frontend-preferences-client": "static-1.8083",
  "hub-http-contrib": "static-1.3199",
  "interframe": "static-3.4913",
  "layout-dnd-components": "static-1.12750",
  "layout-dnd-utils": "static-1.11725",
  "property-translator": "static-1.5551",
  "react-codemirror": "static-1.10783",
  "react-colorpicker": "static-2.10364",
  "reference-resolvers-lite": "static-1.8252",
  "rich-text-lib": "static-1.20106",
  "tinymce-data": "static-1.40870",
  "tinymce-themes": "static-1.56755",
  "ui-addon-emoji-picker": "static-1.10039",
  "ui-addon-sales-email": "static-1.5367",
  "ui-brand-identity-lib": "static-1.15855",
  "bender-build-tools": "static-1.3301",
  "hub-http-shared-msw-handlers": "static-1.10346",
  "hubspotter-http-shared-msw-handlers": "static-1.10344",
  "usage-tracker-session-replay": "static-1.5193",
  "base-ui": "static-1.16",
  "react-day-picker": "static-1.5",
  "trellis-theming": "static-1.1103",
  "tanstack-virtual": "static-1.32",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.225",
  "chirp-fetch": "static-1.2044",
  "chatspot-core": "static-1.22075",
  "copilot-toolkit": "static-1.11532",
  "customer-data-objects-ui-components": "static-1.13185",
  "data-fetching-client": "static-1.9815",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.4915",
  "ui-addon-video-player": "static-1.8860",
  "ui-coaching-tips": "static-1.28993",
  "usage-tracker": "static-1.7507",
  "cms-field-types": "static-1.4970",
  "content-icons-ui": "static-1.2272",
  "integrations-lib": "static-1.16651",
  "customer-data-objects": "static-1.7834",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1269",
  "apollo-link-hub-http": "static-2.4807",
  "apollo-stack-hubspot": "static-3.88",
  "graphql": "static-1.84",
  "immer": "static-1.33",
  "immerable": "static-1.4306",
  "ui-addon-iframeable": "static-1.9228",
  "video-components-external": "static-1.11796",
  "video-data-lib": "static-1.35454",
  "audio-components": "static-1.6155",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29590",
  "FileManagerImages": "static-1.37233",
  "foundations-components-legacy": "static-1.1266",
  "html-to-image": "static-1.56",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "salesImages": "static-1.528",
  "ui-universal-auth": "static-1.9164",
  "urlinator": "static-1.4689",
  "video-components": "static-1.13798",
  "video-embed": "static-1.36288",
  "ts-schema": "static-1.4195",
  "ContentData": "static-1.68893",
  "layout-data-lib": "static-1.10050",
  "react-dnd-compat": "static-1.4769",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1699",
  "external-options-client-types": "static-1.4240",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7051",
  "hs-promise-utils": "static-1.5750",
  "inbound-db-properties-service-client": "static-1.3960",
  "NamespacedHubStyle": "static-2.9167",
  "growth-onboarding-confetti": "static-1.3222",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11304",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5655",
  "magpie-types": "static-1.5115",
  "simple-logging-lib": "static-1.3204",
  "avatar-components": "static-1.2654",
  "customer-data-ui-utilities": "static-1.9978",
  "growth-onboarding-feedback-components": "static-1.6734",
  "flux-actions": "static-1.350",
  "hubspot-apollo-client": "static-1.5034",
  "integrations-error-boundary-lib": "static-1.14066",
  "integrations-tracking-lib": "static-1.5763",
  "laboratory-lib": "static-3.7307",
  "native-integrations-shared-strings": "static-1.7935",
  "redux-observable": "static-1.11",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10414",
  "unified-auth": "static-1.678",
  "breeze-engine-core": "static-1.547",
  "ably": "static-2.2",
  "highlight.js": "static-1.81",
  "navigation-messaging": "static-1.7734",
  "content-media-composition-data-lib": "static-1.12818",
  "content-media-compositions": "static-2.16825",
  "idb-keyval": "static-1.46",
  "media-bridge-lib": "static-1.19202",
  "unified-auth-core-lib": "static-1.960",
  "social-insights-client-types": "static-1.22478",
  "advanced-menus-core": "static-1.15391",
  "advanced-menus-lib": "static-1.12291",
  "ExportDialog": "static-6.10534",
  "ui-memberships-settings-lib": "static-1.34469",
  "conditional-properties-service-client": "static-1.3911",
  "crm-pipelines-api-client-types": "static-1.4251",
  "fdsr-migration-layer": "static-1.170",
  "framework-builder-read-service-client": "static-1.4119",
  "framework-data-schema-quick-fetch": "static-1.6956",
  "inbound-db-meta-service-client": "static-1.3702",
  "multi-currency-client-types": "static-1.3805",
  "persist-promise": "static-1.3856",
  "foundations-components-test-utils": "static-1.5724",
  "reactive-lib": "static-1.881",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.493",
  "universal-page-editor-lib": "static-1.3167",
  "adobe-sign-auth-lib": "static-1.132",
  "ads-unified-auth-lib": "static-1.609",
  "google-sheets-integration-lib": "static-1.697",
  "microsoft-drive-integration-lib": "static-1.865",
  "surveymonkey-integration-lib": "static-1.149",
  "slack-ui-library": "static-1.10553",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3885",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15390",
  "simple-menus-lib": "static-1.16907",
  "crm-record-cards-service-types": "static-1.3699",
  "location-customization-utils-lib": "static-1.9713",
  "react-flip-move": "static-1.73"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30575",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55006",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8177",
  "hubspot-dlb": "/hubspot-dlb/static-2.1854",
  "HubStyleTokens": "/HubStyleTokens/static-2.11624",
  "I18n": "/I18n/static-7.1643",
  "quartz": "/quartz/static-1.7233",
  "quartz-config": "/quartz-config/static-1.1011",
  "quartz-core": "/quartz-core/static-1.6452",
  "react-dlb": "/react-dlb/static-1.82",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reselect": "/reselect/static-3.7",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.836",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.54993",
  "feedback-utils": "/feedback-utils/static-1.54997",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4619",
  "forms-utils-lib": "/forms-utils-lib/static-1.12878",
  "foundations-assets": "/foundations-assets/static-1.5029",
  "foundations-components": "/foundations-components/static-1.8241",
  "foundations-theming": "/foundations-theming/static-1.4593",
  "hub-http": "/hub-http/static-1.6376",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4132",
  "HubStyle": "/HubStyle/static-2.11931",
  "icons": "/icons/static-2.660",
  "immutable": "/immutable/static-2.79",
  "quick-fetch": "/quick-fetch/static-1.4030",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.188",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16850",
  "react-select-plus": "/react-select-plus/static-1.107",
  "react-utils": "/react-utils/static-2.5454",
  "react-virtualized": "/react-virtualized/static-2.101",
  "redux": "/redux/static-4.16",
  "StyleGuideUI": "/StyleGuideUI/static-3.490",
  "tinymce-plugins": "/tinymce-plugins/static-1.57899",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1196",
  "UIComponents": "/UIComponents/static-3.8570",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9637",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3514",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3510",
  "quartz-webpack": "/quartz-webpack/static-1.3457",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2309",
  "property-description-translator": "/property-description-translator/static-1.3995",
  "HeadJS": "/HeadJS/static-2.775",
  "framer-motion": "/framer-motion/static-1.74",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3288",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.154",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.224",
  "moment-timezone": "/moment-timezone/static-5.85",
  "jasmine": "/jasmine/static-4.4480",
  "jasmine-runner": "/jasmine-runner/static-1.6612",
  "dispatcher": "/dispatcher/static-1.139",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.850",
  "hubspotter-http": "/hubspotter-http/static-1.4764",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.549",
  "module-federation": "/module-federation/static-1.28",
  "quartz-auth": "/quartz-auth/static-1.908",
  "quartz-head": "/quartz-head/static-1.898",
  "quartz-i18n": "/quartz-i18n/static-1.908",
  "quartz-routing": "/quartz-routing/static-1.663",
  "quartz-test": "/quartz-test/static-1.908",
  "quartz-tracking": "/quartz-tracking/static-1.612",
  "trellis-components": "/trellis-components/static-1.2272",
  "ui-fonts": "/ui-fonts/static-1.886",
  "usage-tracker-container": "/usage-tracker-container/static-1.7497",
  "usage-tracker-core": "/usage-tracker-core/static-1.7357",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.159",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7403",
  "reference-resolvers": "/reference-resolvers/static-1.8331",
  "sanitize-text": "/sanitize-text/static-1.8302",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "ReduxMessenger": "/ReduxMessenger/static-2.10519",
  "sanitize": "/sanitize/static-1.4633",
  "outpost": "/outpost/static-1.4325",
  "rpc-client-utils": "/rpc-client-utils/static-1.4815",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4510",
  "floating-ui": "/floating-ui/static-1.59",
  "hs-story-utils": "/hs-story-utils/static-1.9579",
  "react-aria": "/react-aria/static-1.68",
  "react-create-root-preference": "/react-create-root-preference/static-1.41",
  "tanstack-table": "/tanstack-table/static-1.57",
  "trellis-assets": "/trellis-assets/static-1.2253",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3076",
  "foundations-theming-base": "/foundations-theming-base/static-1.3578",
  "stylex": "/stylex/static-1.36",
  "hs-locale-management": "/hs-locale-management/static-1.195",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.8",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9344",
  "atom": "/atom/static-1.5230",
  "codemirror": "/codemirror/static-5.97",
  "content-assistance-lib": "/content-assistance-lib/static-1.7998",
  "ContentUtils": "/ContentUtils/static-1.68818",
  "data-token-picker": "/data-token-picker/static-1.16686",
  "file-manager-components": "/file-manager-components/static-1.24082",
  "FileManagerCore": "/FileManagerCore/static-1.39581",
  "FileManagerLib": "/FileManagerLib/static-1.39722",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8083",
  "hub-http-contrib": "/hub-http-contrib/static-1.3199",
  "interframe": "/interframe/static-3.4913",
  "layout-dnd-components": "/layout-dnd-components/static-1.12750",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11725",
  "property-translator": "/property-translator/static-1.5551",
  "react-codemirror": "/react-codemirror/static-1.10783",
  "react-colorpicker": "/react-colorpicker/static-2.10364",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8252",
  "rich-text-lib": "/rich-text-lib/static-1.20106",
  "tinymce-data": "/tinymce-data/static-1.40870",
  "tinymce-themes": "/tinymce-themes/static-1.56755",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10039",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5367",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15855",
  "bender-build-tools": "/bender-build-tools/static-1.3301",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10346",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10344",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5193",
  "base-ui": "/base-ui/static-1.16",
  "react-day-picker": "/react-day-picker/static-1.5",
  "trellis-theming": "/trellis-theming/static-1.1103",
  "tanstack-virtual": "/tanstack-virtual/static-1.32",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.225",
  "chirp-fetch": "/chirp-fetch/static-1.2044",
  "chatspot-core": "/chatspot-core/static-1.22075",
  "copilot-toolkit": "/copilot-toolkit/static-1.11532",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13185",
  "data-fetching-client": "/data-fetching-client/static-1.9815",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.4915",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8860",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28993",
  "usage-tracker": "/usage-tracker/static-1.7507",
  "cms-field-types": "/cms-field-types/static-1.4970",
  "content-icons-ui": "/content-icons-ui/static-1.2272",
  "integrations-lib": "/integrations-lib/static-1.16651",
  "customer-data-objects": "/customer-data-objects/static-1.7834",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1269",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4807",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.88",
  "graphql": "/graphql/static-1.84",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4306",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9228",
  "video-components-external": "/video-components-external/static-1.11796",
  "video-data-lib": "/video-data-lib/static-1.35454",
  "audio-components": "/audio-components/static-1.6155",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29590",
  "FileManagerImages": "/FileManagerImages/static-1.37233",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1266",
  "html-to-image": "/html-to-image/static-1.56",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "salesImages": "/salesImages/static-1.528",
  "ui-universal-auth": "/ui-universal-auth/static-1.9164",
  "urlinator": "/urlinator/static-1.4689",
  "video-components": "/video-components/static-1.13798",
  "video-embed": "/video-embed/static-1.36288",
  "ts-schema": "/ts-schema/static-1.4195",
  "ContentData": "/ContentData/static-1.68893",
  "layout-data-lib": "/layout-data-lib/static-1.10050",
  "react-dnd-compat": "/react-dnd-compat/static-1.4769",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1699",
  "external-options-client-types": "/external-options-client-types/static-1.4240",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7051",
  "hs-promise-utils": "/hs-promise-utils/static-1.5750",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3960",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9167",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3222",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11304",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5655",
  "magpie-types": "/magpie-types/static-1.5115",
  "simple-logging-lib": "/simple-logging-lib/static-1.3204",
  "avatar-components": "/avatar-components/static-1.2654",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9978",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6734",
  "flux-actions": "/flux-actions/static-1.350",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5034",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14066",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5763",
  "laboratory-lib": "/laboratory-lib/static-3.7307",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7935",
  "redux-observable": "/redux-observable/static-1.11",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10414",
  "unified-auth": "/unified-auth/static-1.678",
  "breeze-engine-core": "/breeze-engine-core/static-1.547",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.81",
  "navigation-messaging": "/navigation-messaging/static-1.7734",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12818",
  "content-media-compositions": "/content-media-compositions/static-2.16825",
  "idb-keyval": "/idb-keyval/static-1.46",
  "media-bridge-lib": "/media-bridge-lib/static-1.19202",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.960",
  "social-insights-client-types": "/social-insights-client-types/static-1.22478",
  "advanced-menus-core": "/advanced-menus-core/static-1.15391",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12291",
  "ExportDialog": "/ExportDialog/static-6.10534",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34469",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3911",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4251",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.170",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4119",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6956",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3702",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3805",
  "persist-promise": "/persist-promise/static-1.3856",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5724",
  "reactive-lib": "/reactive-lib/static-1.881",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.493",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3167",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.132",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.609",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.697",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.865",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.149",
  "slack-ui-library": "/slack-ui-library/static-1.10553",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3885",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15390",
  "simple-menus-lib": "/simple-menus-lib/static-1.16907",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3699",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9713",
  "react-flip-move": "/react-flip-move/static-1.73"
}
};
